<div class="bg-white Main-Header">
    <div class="Logo-Section">
        <div class="back-btn-and-img-sec">
            <img 
                *ngIf="qSerive.screenTemplateDetails && qSerive.screenTemplateDetails['isBack']" 
                style="width:9px; height: 15px; margin-right: 10px; cursor: pointer;" 
                src="../../../assets/image/back.png"
                (click)="redirectBackUrl()" 
                alt="back"
            />
            <img 
                *ngIf="qSerive.screenTemplateDetails && qSerive.screenTemplateDetails['header_logo']" 
                style="max-width: 50px; height: auto;" 
                [src]="qSerive.screenTemplateDetails['header_logo']" 
                alt="" 
            />
        </div>
        <div *ngIf="qSerive.screenTemplateDetails && qSerive.screenTemplateDetails['header_text']" class="text-dark fs-5 ms-2 Heading-section">{{qSerive.screenTemplateDetails['header_text']}}</div>
    </div>
</div>